import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import {
  CanceledAccepted,
  CanceledMultiple,
  CanceledRejected,
  getAllData,
} from "../../../utils/apis/Canceled/Canceled";
import Pagination from "../../common/Pagination";
import { formatDate } from "../../../utils/common";
import { Submit, EditButton } from "../../common/Button";
import EditOffCanvance from "./Edit";
import pen from "../../../Components/Admin/assets/icons/pen.png";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import Filter_offcanvas from "../../common/common-offcanvas/Filter_offcanvas";
import { ShimmerButton, ShimmerTable } from "react-shimmer-effects";
import { Context } from "../../../utils/context";
import { getSetup } from "../../../utils/apis/masters/masters";
const Users = ({
  status,
  setStatus,
  handleExportCSV,
  handlePrint,
  handleExportExcel,
  isAllow,
  convertrate,
}) => {
  const { shimmerLoader, setShimmerLoader } = useContext(Context);
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    alert(JSON.stringify(data));
  };

  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value)),
        );
      }
    }
  };

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [TotalEntries, setTotalEntries] = useState(1);
  const [TotalPages, setTotalPages] = useState(1);
  const [perPage, setperPage] = useState(10);

  const getData = async () => {
    setShimmerLoader(true);
    const res = await getAllData(
      currentPage,
      perPage,
      getValues("contact"),
      getValues("name"),
      getValues("from"),
      getValues("to"),
      getValues("state_id")?.value,
      getValues("city_id")?.value,
      getValues("type")?.value,
    );
    setData(res.data);
    setCurrentPage(res?.data?.currentPage);
    setperPage(res?.data?.per_page);
    setTotalEntries(res?.data?.totalEntries);
    setTotalPages(res?.data?.totalPages);

    if (res?.data?.data) {
      const ids = res?.data?.data?.map((item) => item.id);
      setAllChecked(ids);
    } else {
      setAllChecked([]);
    }

    setShimmerLoader(false);
  };

  useEffect(() => {
    getData(search);
  }, [perPage, currentPage]);

  const Accepted = async (id) => {
    const data = {
      id: id,
      accepted_rejected: 1,
    };

    // console.log(id);
    const res = await CanceledAccepted(data);
    if (res.success) {
      getData();
      setStatus(res.success);
    }
  };

  const Rejected = async (id) => {
    const data = {
      id: id,
      accepted_rejected: 0,
    };

    // console.log(id);
    const res = await CanceledRejected(data);
    if (res.success) {
      getData();
    }
  };

  // const Multiple = async () => {
  //   const data = {
  //     ids: selectAllChecked,
  //     accepted_rejected: 1,
  //   };

  //   const res = await CanceledMultiple(data);
  //   if (res.success) {
  //     getData();
  //     setStatus(res.success);
  //   }
  // };

  const [show1, setShowEdit] = useState(0);
  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  const [search, setSearch] = useState({
    name: "",
    serviceNo: "",
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    const updatedSearch = {
      ...search,
      [id]: value,
    };
    setSearch(updatedSearch);

    // Send both values
    getData(updatedSearch);
  };

  const [modalShow2, setModalShow2] = React.useState(false);

  // const [setup, setSetup] = useState([]);
  // const getMastersData = async () => {
  //   const res = await getSetup();
  //   await setSetup(res?.data);
  // };

  // useEffect(() => {
  //   getMastersData();
  // }, []);
  // const convertrate = (amount) => {
  //   const inr = Number(amount);
  //   const rate = Number(setup.withdraw_exchange_rate);
  //   const total = (inr * rate).toFixed(2);
  //   return total;
  // };
  return (
    <div className="search-investor mt-3">
      <div className="investor-main">
        <div>
          <p className="sub">
            <FontAwesomeIcon icon="fa-solid fa-location-dot" className="me-3" />
            Users
          </p>
        </div>
        <div className="filterdiv">
          <button onClick={() => setModalShow2(true)} className="filterbtn">
            <FontAwesomeIcon icon={faFilter} />
            &nbsp;Filter
          </button>
        </div>
      </div>

      {isAllow?.includes(42) ? (
        <div className="inward-payment">
          <div className="nav-link active">
            <div className="dt-buttons btn-group flex-wrap">
              <button
                className="btn btn-secondary buttons-excel buttons-html5 ml-1 Excel_btn"
                tabindex="0"
                aria-controls="DataTables_Table_0"
                type="button"
                onClick={() => handleExportExcel(data, "Users")}
              >
                <span>Excel</span>
              </button>
              <button
                className="btn btn-secondary buttons-csv buttons-html5 CSV_btn"
                tabindex="0"
                aria-controls="DataTables_Table_0"
                type="button"
                onClick={() => handleExportCSV(data, "Users")}
              >
                <span>CSV</span>
              </button>
              <button
                className="btn btn-secondary buttons-print Print_btn"
                tabindex="0"
                aria-controls="DataTables_Table_0"
                type="button"
                onClick={() => handlePrint(data, "Users")}
              >
                <span>Print</span>
              </button>

              <input
                type="number"
                className="ps-3"
                onChange={(e) => setperPage(e.target.value)}
                placeholder="Enter Per Page Data"
              ></input>
              {/* <button
                className="btn btn-info buttons-print Print_btn"
                tabindex="0"
                aria-controls="DataTables_Table_0"
                type="button"
                onClick={() => Multiple()}
              >
                <span>Submit Multiple</span>
              </button> */}
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
      {/* table started */}
      <div className="table-main">
        <div className="table-responsive mt-2">
          {shimmerLoader ? (
            <>
              <ShimmerTable row={2} col={12} width={100} />
            </>
          ) : (
            <table className="table table-bordered  table-striped">
              <thead>
                <tr>
                  {/* <th className="name">
                    <input
                      type="checkbox"
                      value="selectAll"
                      checked={allChecked.length === selectAllChecked.length}
                      onChange={handleChange}
                      id="selectAll"
                      className="me-1"
                    ></input>
                    Select All
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th> */}
                  <th className="name">
                    Payment Date
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>
                  <th className="name">
                    Investor Name
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>
                  <th className="name">
                    Service No
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>
                  <th className="name">
                    State
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>
                  <th className="name">
                    District
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>
                  <th className="name">
                    A/C No
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>
                  <th className="name">
                    IFSC Code
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>

                  <th className="name">
                    Withdrawal Amount
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>

                  <th className="name">
                    Bank Charges
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>
                  <th className="name">
                    Payment Type
                    <div className="triangle"></div>
                    <div className="triangle2"></div>
                  </th>

                  {/* <th className="name">
                  Total Amount
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th> */}
                  {isAllow?.includes(44) ? (
                    <th className="name">
                      Action
                      <div className="triangle"></div>
                      <div className="triangle2"></div>
                    </th>
                  ) : (
                    <></>
                  )}
                  {/* {isAllow?.includes(45) ? (
                    <th className="name">
                      Withdrawal Date
                      <div className="triangle"></div>
                      <div className="triangle2"></div>
                    </th>
                  ) : (
                    <></>
                  )} */}
                </tr>
                {/*  onClick={() => setModalShow(true)} <ScreenShot show={modalShow} onHide={() => setModalShow(false)} /> */}
              </thead>
              <tbody>
                {data?.data?.map((data, index) => (
                  <tr className="odd" key={index}>
                    {/* <td>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        value={data?.id}
                        name="perselected"
                        checked={selectAllChecked.includes(data?.id)}
                        onChange={handleChange}
                        id="flexCheckDefault"
                      ></input>
                    </td> */}
                    <td>{formatDate(data?.createdAt)}</td>
                    <td>
                      {data?.user?.f_name} {data?.user?.l_name}
                    </td>
                    <td>{data?.user?.contact_no}</td>
                    <td>{data?.user?.users_detail?.state?.name}</td>
                    <td>{data?.user?.users_detail?.city?.name}</td>
                    <td>{data?.ac_no}</td>
                    <td>{data?.ifsc_code}</td>
                    <td>{convertrate(data?.amount)}</td>
                    <td>{convertrate(data?.bank_charges)}</td>
                    <td>{data?.withdrawn_type}</td>
                    {/* <td>{data?.user?.total}</td> */}
                    {isAllow?.includes(44) ? (
                      <td>
                        {" "}
                        <Submit
                          handleSubmit={() => Accepted(data?.id)}
                          name={"Accept"}
                        />
                        <Submit
                          handleSubmit={() => Rejected(data?.id)}
                          name={"Rejected"}
                        />
                        {/* <Button
                        onClick={()=> Rejected(data?.id)}
                        type="button"
                        className="btn btn-primary me-1 mt-5"
                      >
                        Cancel
                      </Button> */}
                      </td>
                    ) : (
                      <></>
                    )}
                    {/* {isAllow?.includes(45) ? (
                      <td>
                        {" "}
                        <Button
                          onClick={() => handleShow1(data?.id)}
                          type="button"
                          className="btn btn-primary me-1"
                        >
                          <img src={pen} className="pen" alt="" />
                        </Button>
                      </td>
                    ) : (
                      <></>
                    )} */}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      {/* table ended */}
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        TotalPages={TotalPages}
        TotalEntries={TotalEntries}
        perPage={perPage}
        search={search}
      />
      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}

      {["end"].map((placement, idx) => (
        <Filter_offcanvas
          placement={placement}
          key={idx}
          show={modalShow2}
          onHide={() => setModalShow2(false)}
          setValue={setValue}
          getValues={getValues}
          getData={getData}
          register={register}
          reset={reset}
          control={control}
        />
      ))}
    </div>
  );
};

export default Users;
